/*
 *
 * Home actions
 *
 */

import * as Types from "./constants";

export function showSuccess(payload) {
  return {
    type: Types.TOAST_SUCCESS,
    payload: payload,
  };
}

export function showError(payload) {
  return {
    type: Types.TOAST_ERROR,
    payload: payload,
  };
}

export function getAdviserList(payload) {
  return {
    type: Types.GET_ADVISER_LIST_REQUESTED,
    payload: payload,
  };
}

export function getCategoryList() {
  return {
    type: Types.GET_CATEGORY_LIST_REQUESTED,
  };
}

export function getContactList() {
  return {
    type: Types.GET_CONTACT_LIST_REQUESTED,
  };
}

export function getInboxChatList(payload) {
  return {
    type: Types.GET_INBOX_CHAT_LIST_REQUESTED,
    payload,
  };
}

export function getSendChatList(payload) {
  return {
    type: Types.GET_SEND_CHAT_LIST_REQUESTED,
    payload,
  };
}

export function getArchiveChatList(payload) {
  return {
    type: Types.GET_ARCHIVE_CHAT_LIST_REQUESTED,
    payload,
  };
}

export function setTagMessage(payload) {
  return {
    type: Types.SET_TAG_MESSAGE_REQUESTED,
    payload,
  };
}

export function sendMessage(payload) {
  return {
    type: Types.SEND_MESSAGE_REQUESTED,
    payload,
  };
}

export function getHamrazHistory(payload) {
  return {
    type: Types.GET_HAMRAZ_HISTORY_REQUESTED,
    payload,
  };
}

export function setHamrazHistoryData(payload) {
  return {
    type: Types.SET_HAMRAZ_HISTORY_DATA,
    payload,
  };
}

export function sendAndRemoveMessage(payload) {
  return {
    type: Types.SEND_AND_REMOVE_MESSAGE_REQUESTED,
    payload,
  };
}

export function sendAndArchiveMessage(payload) {
  return {
    type: Types.SEND_AND_ARCHIVE_MESSAGE_REQUESTED,
    payload,
  };
}

export function toggleShowMessageDialog(payload) {
  return {
    type: Types.TOGGLE_SHOW_MESSAGE_DIALOG,
    payload,
  };
}

export function setMessage(message) {
  return {
    type: Types.SET_MESSAGE,
    payload: message,
  };
}

export function seenMessage(message) {
  return {
    type: Types.SEEN_MESSAGE_REQUESTED,
    payload: message,
  };
}

export function removeContact(message) {
  return {
    type: Types.REMOVE_CONTACT_REQUESTED,
    payload: message,
  };
}

export function setTargetPage(page) {
  return {
    type: Types.SET_PAGE_TARGET,
    payload: page,
  };
}

export function setNewMassageCount() {
  return {
    type: Types.SET_NEW_MESSAGES_COUNT,
  };
}

export function setOpenConsultantDialog(boolean) {
  return {
    type: Types.SET_OPEN_CONSULTANT_DIALOG,
    payload: boolean,
  };
}

export function setOpenMessageDialog(boolean) {
  return {
    type: Types.SET_OPEN_MESSAGE_DIALOG,
    payload: boolean,
  };
}
